<template>
  <div
    class="result-bar"
    @mouseenter="enter()"
    @mouseleave="leave()"
    @mousemove="move"
  >
    <div class="keeping-them-text">
      <div class="span key">{{ currentResult["Keeping Them"] }}:</div>
      <span class="value">{{
        currentResult["Percentage of Industry Total"]
      }}</span>
      <span class="tooltip-icon"></span>
    </div>
    <div class="bar" @click.self="enter()" :class="convertToSlug()">
      <div class="bar-result" :style="{ width: resultNumber() }"></div>
    </div>
    <BarToolTip
      :keepType="currentResult['Keeping Them']"
      :totalSpent="currentResult['Total Spend']"
      :industry="industry"
      :active="popUpActive"
      :mouse_x="mouseX"
      :mouse_y="mouseY"
      @close="close()"
    />
  </div>
</template>

<script>
import BarToolTip from "./BarToolTip.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  name: "ResultBar",
  components: {
    BarToolTip
  },
  props: {
    currentResult: {}
  },
  data() {
    return {
      popUpActive: false,
      mouseX: null,
      mouseY: null
    };
  },
  computed: {
    ...mapGetters({
      industry: "getSelectedIndustry"
    })
  },
  methods: {
    ...mapActions({
      setTooltip: "setTooltip"
    }),
    resultNumber() {
      return this.currentResult["Percentage of Industry Total"];
    },
    enter() {
      this.setTooltip(this.currentResult["Keeping Them"]);
      this.popUpActive = true;
    },
    leave() {
      this.popUpActive = false;
    },
    move(event) {
      this.mouseX = event.clientX + 10;
      let yOffset = window.window.innerHeight - 350;
      this.mouseY = event.clientY > yOffset ? yOffset : event.clientY;
    },
    close() {
      this.popUpActive = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.result-bar {
  margin-bottom: 20px;

  .keeping-them-text {
    font-size: 18px;
    margin-bottom: 10px;
    display: flex;
    align-items: center;

    .value {
      padding-left: 5px;
      font-weight: bold;
    }

    .tooltip-icon {
      width: 15px;
      height: 15px;
      background-image: url("../assets/img/tooltip-icon.svg");
      background-size: contain;
      background-repeat: no-repeat;
      margin-left: 10px;

      @media (min-width: 767px) {
        display: none;
      }
    }
  }
  .bar {
    width: 100%;
    height: 35px;
    position: relative;

    .bar-result {
      position: absolute;
      height: 100%;
      width: 0%;
      top: 0;
      left: 0;
      transition: all 0.3s ease-in-out;
    }

    &.stocked-up {
      background-color: #3c2008;

      .bar-result {
        background: #fffb5d;
        box-shadow: 0px 0px 30px #fffb5d;
      }
    }
    &.fed {
      background-color: #3c2008;

      .bar-result {
        background: #f18334;
        box-shadow: 0px 0px 30px #ee5136;
      }
    }
    &.on-the-road {
      background-color: #3b131f;

      .bar-result {
        background: #ed527e;
        box-shadow: 0px 0px 30px #ed527e;
      }
    }
    &.educated {
      background-color: #3c2008;
      .bar-result {
        background: #fffb5d;
        box-shadow: 0px 0px 30px #fffb5d;
      }
    }
    &.pampered {
      background: #163f3b;

      .bar-result {
        background: #6ffbed;
        box-shadow: 0px 0px 30px #6ffbed;
      }
    }
    &.entertained {
      background: #3b130d;

      .bar-result {
        background: #ee5136;
        box-shadow: 0px 0px 30px #ee5136;
      }
    }
    &.caffeinated {
      background: #163f31;

      .bar-result {
        background: #70fbc3;
        box-shadow: 0px 0px 30px #70fbc3;
      }
    }
    &.connected {
      background: #163f3b;

      .bar-result {
        background: #6ffbed;
        box-shadow: 0px 0px 30px #6ffbed;
      }
    }
    &.equipped {
      background: #3b130d;

      .bar-result {
        background: #ee5136;
        box-shadow: 0px 0px 30px #ee5136;
      }
    }
    &.fit {
      background: #163f31;

      .bar-result {
        background: #70fbc3;
        box-shadow: 0px 0px 30px #70fbc3;
      }
    }
  }
}
</style>
